import Profile from "./views";


export default Profile